import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { TextareaAddonComponent } from 'src/app/common/textarea-addon/textarea-addon.component';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { DatePipe } from '@angular/common';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { ModuleMenu } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-concept-proposal',
  templateUrl: './ist-concept-proposal.component.html',
  styleUrls: ['./ist-concept-proposal.component.scss']
})
export class IstConceptProposalComponent implements OnInit ,IDeactivateComponent{

  formFields;
  ApplicationID: string;
  operations: any = [];
  permission: string = "";
  userType: string = "";
  content: any;
  menudata: ModuleMenu;
  myDate = new Date();
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  staticformFields: any;

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private modalService: NgbModal,
    private appFunctions: AppFunctionsService,
    public route: ActivatedRoute,
    private router: Router,
    private header: HeadService,
    private summaryService: IstSummaryService,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    public datepipe: DatePipe
  ) {
    this.datashareService.setOBJECTIVES("");
    this.datashareService.setSTUDY_DESIGN("");
    this.datashareService.setHYPOTHESIS("");
    this.datashareService.setREGULATIONS("");
    this.datashareService.setBACKGROUND("");
    this.datashareService.setTOOLS_PROCEDURES("");
    this.datashareService.setPRIMARY_OUTCOMES("");
    this.datashareService.setSECONDARY_OUTCOMES("");
    this.setFormPermissions();
  }

  conceptProposalForm: UntypedFormGroup;

  ngOnInit() {

    this.getStaticFiledsData('SCR-004');
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });    
    setTimeout(() => {
      this.setFormPermissions();
      if (this.permission == "view") {
        this.conceptProposalForm.disable();
      }
      else{
        this.conceptProposalForm.enable();
      }
    }, 700);
    this.userType = this.userService.getUserType();
    this.conceptProposalForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      OBJECTIVES: new UntypedFormControl(""),
      BACKGROUND: new UntypedFormControl(""),
      HYPOTHESIS: new UntypedFormControl(""),
      STUDY_DESIGN: new UntypedFormControl(""),
      REGULATIONS: new UntypedFormControl(""),
      TOOLS_PROCEDURES: new UntypedFormControl(""),
      PRIMARY_OUTCOMES: new UntypedFormControl(""),
      SECONDARY_OUTCOMES: new UntypedFormControl(""),
    });

    this.datashareService.OBJECTIVES.subscribe(x => {
      this.conceptProposalForm.controls["OBJECTIVES"].setValue(x);
    });
    this.datashareService.HYPOTHESIS.subscribe(x => {
      this.conceptProposalForm.controls["HYPOTHESIS"].setValue(x);
    });
    this.datashareService.STUDY_DESIGN.subscribe(x => {
      this.conceptProposalForm.controls["STUDY_DESIGN"].setValue(x);
    });
    this.datashareService.REGULATIONS.subscribe(x => {
      this.conceptProposalForm.controls["REGULATIONS"].setValue(x);
    });
    this.datashareService.BACKGROUND.subscribe(x => {
      this.conceptProposalForm.controls["BACKGROUND"].setValue(x);
    });

    this.datashareService.TOOLS_PROCEDURES.subscribe(x => {
      this.conceptProposalForm.controls["TOOLS_PROCEDURES"].setValue(x);
    });
    this.datashareService.PRIMARY_OUTCOMES.subscribe(x => {
      this.conceptProposalForm.controls["PRIMARY_OUTCOMES"].setValue(x);
    });
    this.datashareService.SECONDARY_OUTCOMES.subscribe(x => {
      this.conceptProposalForm.controls["SECONDARY_OUTCOMES"].setValue(x);
    });
    if (this.permission != "view") {
      this.operations = [
        { name: 'Save', type: 'submit', callback: this.save, self: this }
      ]
    }
    else {
      this.operations = [];
      this.conceptProposalForm.disable();
    }
   

    this.getScreenData();
  }

  private setFormPermissions()
  {
    this.permission = "";
    let  TempPermission=this.commonService.getPagePermission("IST05");
    if (TempPermission != null && TempPermission != undefined) {
      this.permission = TempPermission.toLowerCase();
    }  
  if (this.permission == "view") {
   // this.generalInformationForm.disable();
   this.operations = [];
  }
  else {
    this.operations = [
      { name: 'Save', type: 'submit', callback: this.save, self: this }
    ]
  }
}

  getScreenData() {
    if (this.ApplicationID != "" && this.ApplicationID != undefined) {
      this.summaryService.getScreenDataForEdit('api/ISTConceptProposal/GetConceptProposalData?ApplicationID=' + this.ApplicationID).subscribe((result) => {
        if (result != null) {
          this.conceptProposalForm.patchValue({
            ID: result["ID"],
            APPLICATION_ID: result["APPLICATION_ID"],
            OBJECTIVES: result["OBJECTIVES"],
            BACKGROUND: result["BACKGROUND"],
            HYPOTHESIS: result["HYPOTHESIS"],
            STUDY_DESIGN: result["STUDY_DESIGN"],
            REGULATIONS: result["REGULATIONS"],
            TOOLS_PROCEDURES: result["TOOLS_PROCEDURES"],
            PRIMARY_OUTCOMES: result["PRIMARY_OUTCOMES"],
            SECONDARY_OUTCOMES: result["SECONDARY_OUTCOMES"]
          });
          this.bindData();
debugger;
          if(this.extendedForm!=null && this.extendedForm!=undefined)
          {
            debugger;
            this.extendedForm.rowid = result["ID"];
            this.extendedForm.getResponse();
          }
         
        }
      });
    }
  }
  bindData() {
    this.datashareService.setOBJECTIVES(this.conceptProposalForm.controls["OBJECTIVES"].value);
    this.datashareService.setHYPOTHESIS(this.conceptProposalForm.controls["HYPOTHESIS"].value);
    this.datashareService.setBACKGROUND(this.conceptProposalForm.controls["BACKGROUND"].value);
    this.datashareService.setREGULATIONS(this.conceptProposalForm.controls["REGULATIONS"].value);
    this.datashareService.setSTUDY_DESIGN(this.conceptProposalForm.controls["STUDY_DESIGN"].value);
    this.datashareService.setTOOLS_PROCEDURES(this.conceptProposalForm.controls["TOOLS_PROCEDURES"].value);
    this.datashareService.setPRIMARY_OUTCOMES(this.conceptProposalForm.controls["PRIMARY_OUTCOMES"].value);
    this.datashareService.setSECONDARY_OUTCOMES(this.conceptProposalForm.controls["SECONDARY_OUTCOMES"].value);
  }
  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.conceptProposalForm, this.ApplicationID, this.extendedForm, this.validateControls);
  }

  save() {
    if (this.validateControls()) {
      this.conceptProposalForm.markAsPristine();
      var formData = this.conceptProposalForm.value;
      if (this.ApplicationID == null || this.ApplicationID == undefined || this.ApplicationID == "") {
        this.SaveIST_GI_APP().subscribe((res) => {
          if (res.Status === 0) {
            this.ApplicationID = res["TransactionID"];
            this.datashareService.setApplicationID(this.ApplicationID);
            formData["APPLICATION_ID"] = this.ApplicationID;
            this.summaryService.Insert('api/ISTConceptProposal/Insert', formData).subscribe((result) => {
              if (result.Status === 0) {
                this.conceptProposalForm.controls["ID"].setValue(result.TransactionID);
                this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
                  if (result1.Status === 0) {
                    this.commonService.SuccessBanner(result.Message);
                    if(this.extendedForm!=null && this.extendedForm!=undefined)
                    {
                      this.extendedForm.IsFormToched=false;}
                    this.refreshPage(this.ApplicationID);
                  }
                  else {
                    this.commonService.ValidationBanner(result1.Message);
                    this.refreshPage(this.ApplicationID);
                  }
                });
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
            });
          }
          else {
            this.commonService.ValidationBanner(res.Message);
          }
        });
      }
      else {
        formData["APPLICATION_ID"] = this.ApplicationID;
        this.summaryService.Insert('api/ISTConceptProposal/Insert', formData).subscribe((result) => {
          if (result.Status === 0 || result.ErrorCode === "NOCHANGES") {
          
            this.conceptProposalForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode === "NOCONTROLS") {
                if (result.Status === 0)
                {
                  this.commonService.SuccessBanner(result.Message);
                  if(this.extendedForm!=null && this.extendedForm!=undefined)
                  {
                    this.extendedForm.IsFormToched=false;}
                }
                else
                {
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else
              {
                if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES")
                {
                  this.commonService.ValidationBanner(result.Message);
                }
               else
               {
                  this.commonService.SuccessBanner("Concept Proposal Details saved successfully");
                  if(this.extendedForm!=null && this.extendedForm!=undefined)
                  {
                    this.extendedForm.IsFormToched=false;
                    this.extendedForm.rowid =this.conceptProposalForm.controls["ID"].value;
                    this.extendedForm.getResponse();
                  }
               }
              }
              });
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }
        });
        //this.conceptProposalForm.markAsPristine();
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.conceptProposalForm.value;

    if(this.staticformFields?.Objectives.IS_MANDATORY && this.staticformFields?.Objectives.IS_Display){
      if (formData.OBJECTIVES === null || formData.OBJECTIVES === "") {
      $("#OBJECTIVES").addClass("ng-touched ng-invalid validate-error");
      $("#OBJECTIVES").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.Objectives.LABEL_NAME} <br/>`;
      isValid = false;
      } else {
      $("#OBJECTIVES").addClass("ng-untouched ng-valid");
      $("#OBJECTIVES").removeClass("ng-touched ng-invalid validate-error");
      }
    } 

    if(this.staticformFields?.Background.IS_MANDATORY && this.staticformFields?.Background.IS_Display){
      if (formData.BACKGROUND === null || formData.BACKGROUND === "") {
      $("#BACKGROUND").addClass("ng-touched ng-invalid validate-error");
      $("#BACKGROUND").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.Background.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#BACKGROUND").addClass("ng-untouched ng-valid");
      $("#BACKGROUND").removeClass("ng-touched ng-invalid validate-error");
    }
  }

    if(this.staticformFields?.Hypothesis.IS_MANDATORY && this.staticformFields?.Hypothesis.IS_Display){
    if (formData.HYPOTHESIS === null || formData.HYPOTHESIS === "") {
      $("#HYPOTHESIS").addClass("ng-touched ng-invalid validate-error");
      $("#HYPOTHESIS").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.Hypothesis.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#HYPOTHESIS").addClass("ng-untouched ng-valid");
      $("#HYPOTHESIS").removeClass("ng-touched ng-invalid validate-error");
    }
  }

    if(this.staticformFields?.Study_Design.IS_MANDATORY && this.staticformFields?.Study_Design.IS_Display){
    if (formData.STUDY_DESIGN === null || formData.STUDY_DESIGN === "") {
      $("#STUDY_DESIGN").addClass("ng-touched ng-invalid validate-error");
      $("#STUDY_DESIGN").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.Study_Design.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#STUDY_DESIGN").addClass("ng-untouched ng-valid");
      $("#STUDY_DESIGN").removeClass("ng-touched ng-invalid validate-error");
    }
  }

    if(this.staticformFields?.Subject_Regulations.IS_MANDATORY && this.staticformFields?.Subject_Regulations.IS_Display){
    if (formData.REGULATIONS === null || formData.REGULATIONS === "") {
      $("#REGULATIONS").addClass("ng-touched ng-invalid validate-error");
      $("#REGULATIONS").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.Subject_Regulations.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#REGULATIONS").addClass("ng-untouched ng-valid");
      $("#REGULATIONS").removeClass("ng-touched ng-invalid validate-error");
    }
  }

    if(this.staticformFields?.AssessmentTools_Procedures.IS_MANDATORY && this.staticformFields?.AssessmentTools_Procedures.IS_Display){
    if (formData.TOOLS_PROCEDURES === null || formData.TOOLS_PROCEDURES === "") {
      $("#TOOLS_PROCEDURES").addClass("ng-touched ng-invalid validate-error");
      $("#TOOLS_PROCEDURES").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.AssessmentTools_Procedures.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#TOOLS_PROCEDURES").addClass("ng-untouched ng-valid");
      $("#TOOLS_PROCEDURES").removeClass("ng-touched ng-invalid validate-error");
    }
  }

    if(this.staticformFields?.Primary_Outcomes.IS_MANDATORY && this.staticformFields?.Primary_Outcomes.IS_Display){
    if (formData.PRIMARY_OUTCOMES === null || formData.PRIMARY_OUTCOMES === "") {
      $("#PRIMARY_OUTCOMES").addClass("ng-touched ng-invalid validate-error");
      $("#PRIMARY_OUTCOMES").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.Primary_Outcomes.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#PRIMARY_OUTCOMES").addClass("ng-untouched ng-valid");
      $("#PRIMARY_OUTCOMES").removeClass("ng-touched ng-invalid validate-error");
    }
  }

    if(this.staticformFields?.Secondary_Outcomes.IS_MANDATORY && this.staticformFields?.Secondary_Outcomes.IS_Display){
    if (formData.SECONDARY_OUTCOMES === null || formData.SECONDARY_OUTCOMES === "") {
      $("#SECONDARY_OUTCOMES").addClass("ng-touched ng-invalid validate-error");
      $("#SECONDARY_OUTCOMES").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.Secondary_Outcomes.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#SECONDARY_OUTCOMES").addClass("ng-untouched ng-valid");
      $("#SECONDARY_OUTCOMES").removeClass("ng-touched ng-invalid validate-error");
    }
  }

    let ExtenMsgs=this.extendedForm.validateControlsMsgs();
    if(ExtenMsgs!=null && ExtenMsgs!=undefined && ExtenMsgs.length>0)
    {
      isValid = false;
      message=message+ this.extendedForm.validateControlsMsgs();
    }

    if (!isValid)
    this.commonService.ValidationBanner(message);
      // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }
  textEntry(title) {
    this.conceptProposalForm.markAsPristine();

    let Contenttext = this.conceptProposalForm.controls[title].value;
    var heading = (title != 'TOOLS_PROCEDURES' && title != 'REGULATIONS') ? title : (title != 'TOOLS_PROCEDURES' ? 'Description of Subject Regulations' : 'Assessment Tools and Procedures');
    let modalRef = this.modalService.open(TextareaAddonComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: heading,
      content: Contenttext,
      ViewMode: this.permission
    }
    modalRef.result.then(result => {       
      this.conceptProposalForm.markAsDirty();
    })
     
    
  }

  SaveIST_GI_APP() {
    let formData = { "ID": '', "STATUS": 0 };
    return this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", formData);
  }

  refreshPage(id) {

    this.summaryService.getISTApplicationSummary("api/common/getistapp/" + id).subscribe(data => {
      this.commonService.appId = data.ID;
      this.commonService.setISTApp(data);
      this.menudata = new ModuleMenu();
      this.menudata.module = "IST";
      this.menudata.operation = "Edit";
      this.menudata.appId = id;
      this.menudata.formstate = "Draft";
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);
      this.datashareService.setApplicationID(id);
      this.router.navigate(['/home/ist/my-applications/application-ext/:' + id + '/general_information_request'], { skipLocationChange: true, queryParams: { id: id, app_ext: true, module: "ist", screen_type: "my-applications" } })

    });
    this.conceptProposalForm.markAsPristine();
  }

  canExit() {
    if (this.conceptProposalForm.dirty || this.extendedForm.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }
}
